<template>
	<div class="container">
		<div class="main_box">

			<!-- 联系我们 -->
			<fixed></fixed>
			<!-- 联系我们 -->

			<!-- 导航 -->
			<navbar></navbar>
			<!-- 导航 -->


			<!-- ==================== 面包屑 ==================== -->
			<div
				v-if="infoData"
				class="tips_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tips_main">
					<span>
						Home&nbsp;&nbsp;>&nbsp;&nbsp;
						Products&nbsp;&nbsp;>&nbsp;&nbsp;
						{{ infoData.parent_name }}&nbsp;&nbsp;>&nbsp;&nbsp;
					</span>
					{{ infoData.title }}
				</div>
			</div>
			<!-- ==================== 面包屑结束 ==================== -->


			<!-- ==================== Banner ==================== -->
			<div
				v-if="infoData"
				class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/COT/bg.jpeg" />
				<div class="txt_box">
					<div class="tit">
						<span class="font1">CorDx Tyfast</span><span class="font2" style="color: #2E7243;">&nbsp;Cotinine (COT) Rapid Test</span>
					</div>
					<div class="txt">
						CorDx Tyfast Cotinine（COT）Rapid Test is a rapid lateral flow immunoassay for the
						qualitative detection of cotinine, the primary metabolite of nicotine, in human urine at a
						cutoff concentration of 200 ng/mL. The test provides a preliminary screening result to
						aid in the assessment of nicotine exposure.
					</div>
				</div>
			</div>
			<!-- ==================== Banner结束 ==================== -->


			<!-- ==================== 产品区域 ==================== -->
			<div
				class="block_1"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="block_1_main">

					<!-- 产品1 -->
					<div class="product_el mar_r">

						<div class="tips">
							{{ isAcitve == 1 ? 'Ref #: ACT21051-10' : 'Ref #: ACT21051-25' }}
						</div>

						<van-image
							width="100%"
							height="auto"
							:src="
								isAcitve == 1
									? require('@/assets/COT/2.webp')
									: require('@/assets/COT/3.webp')
							"
						/>

						<div class="tit">
							Cotinine (COT) Strips
						</div>

						<div class="txt">
							Package Size
						</div>

						<div class="tag_box">

							<div
								class="tag_el mar_r"
								:class="isAcitve == 1 ? 'active' : ''"
								@click="checkActive(1)"
							>
								10 Tests
							</div>

							<div
								class="tag_el mar_l"
								:class="isAcitve == 2 ? 'active' : ''"
								@click="checkActive(2)"
							>
								25 Tests
							</div>

						</div>

						<div class="txt_box">

							<div class="txt_el">
								● {{ isAcitve == 1 ? '10' : '25' }} Cotinine (COT) Test Strips
							</div>

							<div class="txt_el">
								● {{ isAcitve == 1 ? '10' : '25' }} Urine Cups
							</div>

							<div class="txt_el">
								● 1 Instructions for Use
							</div>

						</div>

						<van-button
							class="btn"
							type="primary"
							color="#2E7243"
							block
							@click="goContact"
						>
							Request Information
						</van-button>

					</div>
					<!-- 产品1结束 -->


					<!-- 产品2 -->
					<div class="product_el mar_l">

						<div class="tips">
							Ref #: ACT21052-10
						</div>

						<van-image
							width="100%"
							height="auto"
							:src="require('@/assets/COT/9.png')"
						/>

						<div class="tit">
							Cotinine (COT) Cassettes
						</div>

						<div class="txt">
							Package Size
						</div>

						<div class="tag_box">

							<div class="tag_el active">
								10 Tests
							</div>

						</div>

						<div class="txt_box">

							<div class="txt_el">
								● 10 Cotinine (COT) Test Cassettes
							</div>

							<div class="txt_el">
								● 10 Urine Cups
							</div>

							<div class="txt_el">
								● 10 Droppers
							</div>

							<div class="txt_el">
								● 1 Instructions for Use
							</div>

						</div>

						<van-button
							class="btn"
							type="primary"
							color="#2E7243"
							block
							@click="goContact2"
						>
							Request Information
						</van-button>

					</div>
					<!-- 产品2结束 -->

				</div>
			</div>
			<!-- ==================== 产品区域结束 ==================== -->


			<!-- ==================== 内容区域 ==================== -->
			<div class="block_2">

				<div class="block_2_main">


					<!-- ================================================== -->
					<!-- Detect Nicotine -->
					<!-- ================================================== -->
					<div
						class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>

						<div class="title">
							Detect Nicotine Exposure from Multiple Sources
						</div>

						<div class="msg_main">

							<div class="msg_el">
								<div>● Cigarettes</div>
								<div>● Cigars</div>
							</div>

							<div class="msg_el">
								<div>● Hookah</div>
								<div>● Chewing Tobacco</div>
							</div>

							<div class="msg_el">
								<div>● Nicotine Patch</div>
								<div>● E-cigarettes</div>
							</div>

							<div class="msg_el">
								<div>● Vape Devices</div>
							</div>

						</div>

					</div>


					<!-- ================================================== -->
					<!-- When and Why -->
					<!-- ================================================== -->
					<div
						class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>

						<div class="title">
							When and Why Are the Tests Ordered?
						</div>

						<div class="msg_main">

							<div class="msg_el">

								<div>
									● Court-ordered testing in child custody cases.
								</div>

								<div>
									● For smoking cessation programs.
								</div>

								<div>
									● When applying for health or life insurance.
								</div>

							</div>

							<div class="msg_el">

								<div>
									● Before certain surgeries.
								</div>

								<div>
									● For employment.
								</div>

								<div>
									● If your doctor suspects nicotine overdose.
								</div>

							</div>

						</div>

					</div>


					<!-- ================================================== -->
					<!-- Performance -->
					<!-- ================================================== -->
					<div
						class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>

						<div class="title">
							Performance Specifications
						</div>

						<div class="msg_main2">

							<div class="tit">

								Performance studies were conducted using the common
								test strip technology employed in both the strip and
								cassette configurations. The two configurations
								utilize identical reagents, membrane materials,
								manufacturing processes, and cutoff concentration.

							</div>


							<!-- Method Comparison -->
							<div class="msg_el2">

								<div class="msg_el2_tit">
									Method Comparison / Accuracy
								</div>

								<div class="msg_el2_main">

									<div class="left">

										A drug-free urine pool was spiked with
										Cotinine at the following concentrations:
										0 ng/mL, 100 ng/mL, 150 ng/mL,
										200 ng/mL, 250 ng/mL, 300 ng/mL
										and 600 ng/mL. The result demonstrates
										&gt; 99% accuracy at +50% above and
										50% below the cut-off concentration.
										The data are summarized below:

									</div>

									<div class="right">

										<van-image
											width="100%"
											height="auto"
											:src="require('@/assets/COT/4.webp')"
										/>

									</div>

								</div>

							</div>


							<!-- Analytical Sensitivity -->
							<div class="msg_el2">

								<div class="msg_el2_tit">
									Analytical Sensitivity
								</div>

								<div class="msg_el2_main">

									<div class="left">

										A drug-free urine pool was spiked with
										Cotinine at the following concentrations:
										0 ng/mL, 100 ng/mL, 150 ng/mL,
										200 ng/mL, 250 ng/mL, 300 ng/mL
										and 600 ng/mL. The result demonstrates
										&gt; 99% accuracy at +50% above and
										50% below the cut-off concentration.
										The data are summarized below:

									</div>

									<div class="right">

										<van-image
											width="100%"
											height="auto"
											:src="require('@/assets/COT/5.webp')"
										/>

									</div>

								</div>

							</div>

						</div>

					</div>


					<!-- ================================================== -->
					<!-- How to Read Test Results -->
					<!-- ================================================== -->
					<div
						class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>

						<div class="title">
							How to Read Test Results
						</div>


						<div class="res_box">


							<!-- Negative -->
							<div class="res_el bg1">

								<div class="left">

									<van-image
										width="auto"
										height="auto"
										:src="require('@/assets/COT/7.webp')"
									/>

								</div>

								<div class="right">

									<div class="tit">
										Negative Result
									</div>

									<div class="txt">

										Two colored lines appear. One distinct
										colored line is visible in the control
										region (C), and another apparent colored
										line is present in the test region (T).

									</div>

									<div class="txt">

										NOTE: The shade of color in the test
										region (T) may vary. However, regardless
										of how faint it might be, any visible
										colored line in the test region (T)
										should be considered negative.

									</div>

								</div>

							</div>


							<!-- Positive -->
							<div class="res_el bg2">

								<div class="left">

									<van-image
										width="auto"
										height="auto"
										:src="require('@/assets/COT/6.webp')"
									/>

								</div>

								<div class="right">

									<div class="tit">
										Positive Result
									</div>

									<div class="txt">

										Only one colored line appears in the
										control region (C). No line appears
										in the test region (T).

									</div>

								</div>

							</div>


							<!-- Invalid -->
							<div class="res_el bg3">

								<div class="left">

									<van-image
										width="auto"
										height="auto"
										:src="require('@/assets/COT/8.webp')"
									/>

								</div>

								<div class="right">

									<div class="tit">
										Invalid Result
									</div>

									<div class="txt">

										No control line appears. This often
										points to insufficient specimen volume
										or incorrect testing procedure.

									</div>

									<div class="txt">

										Review the procedure thoroughly and
										repeat the test using a new test device.

									</div>

								</div>

							</div>


						</div>

					</div>


					<!-- ================================================== -->
					<!-- Download -->
					<!-- ================================================== -->
					<div
						class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>

						<div
							class="title more_title"
						>
							Want to Know More?
						</div>


						<div class="download_box">


							<!-- IFU -->
							<div class="download_el">

								<div class="tit">
									1. Guide Download
								</div>

								<div
									class="txt"
									@click="downloadShow = true"
								>

									<img
										src="../../assets/COT/download.webp"
									/>

									<span>
										Download IFU
									</span>

								</div>

							</div>


							<!-- Sale Sheet -->
							<div class="download_el">

								<div class="tit">
									2. Product Sale Sheet
								</div>

								<div
									class="txt"
									@click="downloadUrl('https://cordx.com/files/COT/CorDx_Tyfast_Cotinine_(COT)_Rapid_Test_Sale_Sheet.pdf')"
								>

									<img
										src="../../assets/COT/download.webp"
									/>

									<span>
										Download CorDx Tyfast Cotinine (COT)
										Rapid Test Sale Sheet
									</span>

								</div>

							</div>


						</div>

					</div>


					<!-- ================================================== -->
					<!-- Back Top -->
					<!-- ================================================== -->
					<div
						class="goTop"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
						@click="goTop"
					>

						<img
							src="../../assets/COT/top.webp"
						/>

						<div class="tit">
							BACK TO TOP
						</div>

					</div>


				</div>

			</div>
			<!-- ==================== 内容区域结束 ==================== -->


			<!-- ==================== Footer ==================== -->
			<footerBox></footerBox>
			<!-- ==================== Footer结束 ==================== -->

		</div>


		<!-- ==================== IFU弹窗 ==================== -->
		<van-popup
			v-model="downloadShow"
			round
			closeable
		>

			<div class="download_popup">

				<div class="title">
					Guide Download
				</div>


				<div
					class="download_el"
					@click="downloadUrl('https://cordx.com/files/COT/IFU_Strip_CorDx_Tyfast_COT_Rapid_Test.pdf')"
				>

					<span>
						IFU Strip CorDx Tyfast COT Rapid Test
					</span>

					<img
						src="../../assets/COT/download.webp"
					/>

				</div>


				<div
					class="download_el"
					@click="downloadUrl('https://cordx.com/files/COT/IFU_Cassette_CorDx_Tyfast_COT_Rapid_Test.pdf')"
				>

					<span>
						IFU Cassette CorDx Tyfast COT Rapid Test
					</span>

					<img
						src="../../assets/COT/download.webp"
					/>

				</div>

			</div>

		</van-popup>


		<!-- ==================== Loading ==================== -->
		<transition name="fade">

			<div
				class="loading"
				v-show="isLoading"
			>

				<van-loading />

			</div>

		</transition>
		<!-- ==================== Loading结束 ==================== -->

	</div>
</template>


<script>

import navbar from '@/component/nav.vue'
import footerBox from '@/component/footer.vue'
import fixed from '@/component/fixed.vue'

import {
	productInfo,
	productCount
} from '@/api/public'

import md5 from 'js-md5'
import moment from 'moment'
import download from 'downloadjs'


export default {

	components: {
		navbar,
		footerBox,
		fixed
	},


	metaInfo() {

		return {

			meta: [

				{
					name: "description",
					content: this.metaDescription
				},

				{
					name: "keywords",
					content: this.metaKeywords
				}

			]

		}

	},


	data() {

		return {

			isLoading: true,

			infoData: null,

			metaDescription: '',

			metaKeywords: '',

			isAcitve: 1,

			downloadShow: false

		}

	},


	created() {

		let that = this

		window.scroll(0, 0)


		// 获取产品信息
		productInfo({

			custom: that.$route.name

		}).then(res => {

			that.infoData = res.data

			document.title =
				res.data.title + ' - CorDx'


			that.metaDescription =
				res.data.description

			that.metaKeywords =
				res.data.keywords


			// OG
			that.setOgTag(
				'og:locale',
				'en_US'
			)

			that.setOgTag(
				'og:title',
				res.data.title
			)

			that.setOgTag(
				'og:description',
				res.data.description
			)

			that.setOgTag(
				'og:image',
				res.data.url
			)

			that.setOgTag(
				'og:image:width',
				'1200'
			)

			that.setOgTag(
				'og:image:height',
				'630'
			)

			that.setOgTag(
				'og:image:type',
				'webp'
			)


			that.isLoading = false


			// 产品访问统计
			let time =
				String(moment(new Date()).valueOf())


			setTimeout(() => {

				productCount({

					language:
						sessionStorage.getItem('lang') == 'en'
							? 2
							: 1,

					cate_id:
						that.infoData.cate_id,

					cert_id:
						that.infoData.cert_id,

					productid:
						that.infoData.id,

					url:
						that.$route.name,

					addtime:
						time,

					sign:
						md5(
							String(that.infoData.cate_id) +
							String(that.infoData.cert_id) +
							String(that.infoData.id) +
							that.$route.name +
							String(time) +
							'CorDx2023'
						)

				}).then(res2 => {})

			}, 10000)

		})

	},


	mounted() {

	},


	watch: {

	},


	methods: {


		// 下载
		downloadUrl(value) {

			download(value)

		},


		// 设置OG
		setOgTag(property, content) {

			const meta =
				document.querySelector(
					`meta[property='${property}']`
				)


			if (meta) {

				meta.setAttribute(
					'content',
					content
				)

			} else {

				const newMeta =
					document.createElement('meta')

				newMeta.setAttribute(
					'property',
					property
				)

				newMeta.setAttribute(
					'content',
					content
				)

				document.head.appendChild(
					newMeta
				)

			}

		},


		// 联系产品1
		goContact() {

			if (this.isAcitve == 1) {

				this.$router.push({

					path: '/contact',

					query: {
						products:
							'Cotinine (COT) Strips-10 Tests'
					}

				})

			} else {

				this.$router.push({

					path: '/contact',

					query: {
						products:
							'Cotinine (COT) Strips-25 Tests'
					}

				})

			}

		},


		// 联系产品2
		goContact2() {

			this.$router.push({

				path: '/contact',

				query: {
					products:
						'Cotinine (COT) Cassettes-10 Tests'
				}

			})

		},


		// 产品规格切换
		checkActive(value) {

			this.isAcitve = value

		},


		// 返回顶部
		goTop() {

			window.scrollTo({

				top: 0,

				behavior: 'smooth'

			})

		}

	}

}

</script>


<style scoped lang="less">
.download_popup{
	padding: 50px;
	.download_el{
		img{
			width: 35px;
		}
		span{
			display: inline-block;
			font-weight: bold;
			font-size: 20px;
			padding-top: 6px;
			padding-right: 2px;
		}
		margin-bottom: 24px;
		cursor: pointer;
	}
	.title{
		padding-bottom: 32px;
		font-weight: bold;
		font-size: 32px;
	}
}
/* ============================================================
   Main
============================================================ */

.main_box {

	width: 100%;


	/* ========================================================
	   Block 2
	======================================================== */

	.block_2 {


		.block_2_main {

			width: 1300px;

			margin: 0 auto;


			/* ================= Back Top ================= */

			.goTop {

				padding: 120px 0 150px;

				text-align: center;

				cursor: pointer;


				img {

					width: 80px;

				}


				.tit {

					padding-top: 20px;

					font-weight: bold;

					font-size: 48px;

					color: #18318E;

				}

			}


			/* ================= Content Box ================= */

			.msg_box {

				width: 100%;


				/* ================= Download ================= */

				.download_box {

					padding: 50px 50px 20px;

					border: 1px solid #999999;

					border-radius: 24px;


					.download_el {

						.txt {

							padding-bottom: 30px;

							cursor: pointer;


							img {

								width: 35px;

								vertical-align: middle;

							}


							span {

								display: inline-block;

								padding-top: 4px;
								padding-left: 5px;

								font-size: 24px;

								vertical-align: middle;

							}

						}


						.tit {

							padding-bottom: 5px;

							font-weight: bold;

							font-size: 42px;

						}

					}

				}


				/* ================= Result ================= */

				.res_box {


					.bg1 {

						background: #EEF5FE;

						border: 2px solid #B8F7CF;

					}


					.bg2 {

						background: #EEF5FE;

						border: 2px solid #FFC9C9;

					}


					.bg3 {

						background: #FFF7EC;

						border: 2px solid #FFD6A7;

					}


					.res_el {

						display: flex;

						align-items: center;

						margin-bottom: 40px;

						padding: 50px;

						border-radius: 24px;


						.left {

							width: 155px;

							flex-shrink: 0;

						}


						.right {

							flex: 1;

							padding-left: 40px;


							.tit {

								font-size: 36px;

								font-weight: bold;

							}


							.txt {

								padding: 5px 0;

								font-size: 24px;

								line-height: 1.6;

							}

						}

					}

				}


				/* ================= Performance ================= */

				.msg_main2 {

					padding: 50px 60px;

					border: 1px solid #999999;

					border-radius: 24px;


					.tit {

						font-size: 24px;

						line-height: 1.8;

					}


					.msg_el2 {

						padding-top: 40px;


						.msg_el2_tit {

							font-weight: bold;

							font-size: 42px;

							line-height: 1.4;

						}


						.msg_el2_main {

							display: flex;


							.left {

								flex: 1;

								padding-top: 10px;

								padding-right: 20px;

								font-weight: bold;

								font-size: 24px;

								line-height: 1.8;

							}


							.right {

								flex: 1;

								padding-left: 20px;


								.van-image {

									display: block;

									width: 100%;

								}

							}

						}

					}

				}


				/* ================= Normal ================= */

				.msg_main {

					display: flex;

					padding: 50px 60px;

					border: 1px solid #999999;

					border-radius: 24px;


					.msg_el {

						flex: 1;

						line-height: 1.8;


						div {

							font-size: 24px;

						}

					}

				}


				/* ================= Title ================= */

				.title {

					padding: 120px 0 40px;

					font-weight: bold;

					font-size: 48px;

					line-height: 1.3;

					text-align: center;

				}

			}

		}

	}


	/* ========================================================
	   Block 1
	======================================================== */

	.block_1 {


		.block_1_main {

			width: 1300px;

			display: flex;

			margin: 0 auto;

			padding: 100px 0 0;


			.product_el {

				position: relative;

				flex: 1;

				padding: 70px 30px 50px;

				border: 1px solid #999999;

				border-radius: 24px;

				overflow: hidden;


				/* Button */

				.btn {

					height: 72px;

					border-radius: 16px;


					.van-button__text {

						font-size: 24px;

					}

				}


				/* Text */

				.txt_box {

					padding-bottom: 70px;


					.txt_el {

						font-size: 24px;

						font-weight: bold;

						line-height: 1.8;

					}

				}


				/* Package */

				.tag_box {

					display: flex;

					padding: 10px 0 25px;


					.tag_el {

						flex: 1;

						padding: 20px 0 15px;

						border: 1px solid #999999;

						border-radius: 16px;

						font-size: 24px;

						text-align: center;

						cursor: pointer;

						box-sizing: border-box;

					}


					.active {

						border-color: #1347E5;

						background: #EEF5FE;

						color: #1347E5;

					}


					.mar_r {

						margin-right: 10px;

					}


					.mar_l {

						margin-left: 10px;

					}

				}


				.txt {

					font-size: 20px;

					color: #666666;

				}


				.tit {

					padding: 20px 0 16px;

					font-size: 30px;

					font-weight: bold;

					line-height: 1.4;

				}


				.tips {

					position: absolute;

					top: 0;

					left: 0;

					width: auto;

					padding: 10px 18px;

					background-color: #2E7243;

					border-radius: 24px 0 24px 0;

					font-size: 20px;

					color: #ffffff;

				}

			}


			.mar_r {

				margin-right: 30px;

			}


			.mar_l {

				margin-left: 30px;

			}

		}

	}


	/* ========================================================
	   Banner
	======================================================== */

	.banner_box {

		position: relative;

		width: 100%;
		
		.txt_box{
			padding: 20px 15px;
			.tit{
				span{
					font-size: 36px;
				}
			}
			.txt{
				padding-top: 10px;
				font-size: 18px;
			}
		}

		img {

			display: block;

			width: 100%;

			min-width: 1300px;

		}

	}


	/* ========================================================
	   Breadcrumb
	======================================================== */

	.tips_box {

		padding: 50px 0 30px;

		background: linear-gradient(
			to right,
			#F2F7FD,
			transparent
		);


		.tips_main {

			width: 1140px;

			margin: 0 auto;

			font-size: 18px;

			line-height: 1.6;


			span {

				color: #0B318F;

				font-size: 18px;

			}

		}

	}


	.icon {

		position: absolute;

	}

}


/* ============================================================
   Global mobile safety
============================================================ */

@media screen and (max-width: 768px) {
		.download_popup {
			width: calc(100vw - 60px);
			box-sizing: border-box;
			padding: 30px 24px;

			.title {
				padding-bottom: 24px;
				font-size: 24px;
			}

			.download_el {
				margin-bottom: 18px;

				span {
					max-width: calc(100% - 45px);
					vertical-align: middle;
					font-size: 15px;
					line-height: 1.5;
				}

				img {
					width: 24px;
					vertical-align: middle;
				}
			}
		}

	.container {

		width: 100%;

		max-width: 100%;


	}


	.main_box {

		width: 100%;

		max-width: 100%;



		/* ======================================================
		   Breadcrumb
		====================================================== */

		.tips_box {

			width: 100%;

			box-sizing: border-box;

			padding: 14px 15px 12px;


			.tips_main {

				width: 100%;

				margin: 0;

				font-size: 12px;

				line-height: 1.6;

				word-break: break-word;


				span {

					font-size: 12px;

					line-height: 1.6;

				}

			}

		}


		/* ======================================================
		   Banner
		====================================================== */

		.banner_box {

			width: 100%;

			overflow: hidden;


			img {

				display: block;

				width: 100%;

				min-width: 0;

				height: auto;

			}

		}


		/* ======================================================
		   Product
		====================================================== */

		.block_1 {

			width: 100%;


			.block_1_main {

				width: 100%;

				display: block;

				box-sizing: border-box;

				margin: 0;

				padding: 25px 15px 0;


				.product_el {

					display: block;

					width: 100%;

					box-sizing: border-box;

					margin: 0 0 20px !important;

					padding: 58px 18px 20px;

					border-radius: 14px;


					/* Product image */

					.van-image {

						display: block;

						width: 100% !important;

						height: auto !important;

					}


					/* Ref */

					.tips {

						top: 0;

						left: 0;

						padding: 8px 12px;

						font-size: 12px;

						line-height: 1.4;

						border-radius: 14px 0 14px 0;

					}


					/* Product title */

					.tit {

						padding: 14px 0 8px;

						font-size: 21px;

						line-height: 1.4;

					}


					/* Package */

					.txt {

						font-size: 14px;

						line-height: 1.5;

					}


					/* Tags */

					.tag_box {

						display: flex;

						width: 100%;

						box-sizing: border-box;

						padding: 8px 0 18px;


						.tag_el {

							padding: 10px 5px 9px;

							font-size: 14px;

							line-height: 1.3;

							border-radius: 10px;

						}


						.mar_r {

							margin-right: 5px;

						}


						.mar_l {

							margin-left: 5px;

						}

					}


					/* Product description */

					.txt_box {

						width: 100%;

						box-sizing: border-box;

						padding-bottom: 25px !important;


						.txt_el {

							font-size: 14px;

							line-height: 1.7;

							word-break: break-word;

						}

					}


					/* Button */

					.btn {

						width: 100%;

						height: 48px !important;

						border-radius: 10px !important;


						.van-button__text {

							font-size: 15px;

						}

					}

				}

			}

		}


		/* ======================================================
		   Content
		====================================================== */

		.block_2 {

			width: 100%;


			.block_2_main {

				width: 100%;

				box-sizing: border-box;

				margin: 0;

				padding: 0 15px;


				.msg_box {

					width: 100%;


					/* ================= Title ================= */

					.title {

						width: 100%;

						box-sizing: border-box;

						padding: 45px 5px 18px;

						font-size: 24px;

						line-height: 1.35;

						text-align: center;

						word-break: break-word;

					}


					/* ================= Normal content ================= */

					.msg_main {

						display: block;

						width: 100%;

						box-sizing: border-box;

						padding: 20px 18px;

						border-radius: 14px;


						.msg_el {

							width: 100%;

							margin-bottom: 12px;

							line-height: 1.7;


							div {

								margin-bottom: 8px;

								font-size: 14px;

								line-height: 1.7;

								word-break: break-word;

							}


							&:last-child {

								margin-bottom: 0;

							}

						}

					}


					/* ==================================================
					   Performance
					================================================== */

					.msg_main2 {

						width: 100%;

						box-sizing: border-box;

						padding: 22px 18px;

						border-radius: 14px;


						.tit {

							font-size: 14px;

							line-height: 1.75;

							word-break: break-word;

						}


						.msg_el2 {

							width: 100%;

							padding-top: 28px;


							.msg_el2_tit {

								font-size: 20px;

								line-height: 1.4;

								word-break: break-word;

							}


							.msg_el2_main {

								display: flex;

								flex-direction: column;

								width: 100%;


								.left {

									width: 100%;

									box-sizing: border-box;

									padding: 10px 0 18px;

									font-size: 14px;

									line-height: 1.75;

									word-break: break-word;

								}


								.right {

									width: 100%;

									box-sizing: border-box;

									padding: 0;

									text-align: center;


									.van-image {

										display: block;

										width: 100% !important;

										height: auto !important;

									}

								}

							}

						}

					}


					/* ==================================================
					   Result
					================================================== */

					.res_box {

						width: 100%;


						.res_el {

							display: block;

							width: 100%;

							box-sizing: border-box;

							margin-bottom: 18px;

							padding: 20px 18px;

							border-radius: 14px;


							/* image */

							.left {

								width: 100%;

								box-sizing: border-box;

								margin-bottom: 15px;

								text-align: center;


								.van-image {

									display: inline-block;

									max-width: 100%;

									height: auto !important;

								}

							}


							/* text */

							.right {

								width: 100%;

								box-sizing: border-box;

								padding-left: 0;


								.tit {

									margin-bottom: 8px;

									font-size: 20px;

									line-height: 1.4;

								}


								.txt {

									padding: 4px 0;

									font-size: 14px;

									line-height: 1.7;

									text-align: left;

									word-break: break-word;

								}

							}

						}

					}


					/* ==================================================
					   Download
					================================================== */

					.download_box {

						width: 100%;

						box-sizing: border-box;

						padding: 22px 18px 5px;

						border-radius: 14px;


						.download_el {

							width: 100%;

							box-sizing: border-box;

							margin-bottom: 18px;


							.tit {

								padding-bottom: 7px;

								font-size: 18px;

								line-height: 1.4;

								word-break: break-word;

							}


							.txt {

								display: flex;

								align-items: flex-start;

								width: 100%;

								box-sizing: border-box;

								padding-bottom: 18px;

								font-size: 14px;

								line-height: 1.5;

								cursor: pointer;


								img {

									flex: 0 0 auto;

									width: 24px;

									height: 24px;

									margin-top: 1px;

								}


								span {

									display: block;

									flex: 1;

									padding-top: 0;

									font-size: 14px;

									line-height: 1.5;

									word-break: break-word;

								}

							}

						}

					}

				}


				/* ==================================================
				   Back Top
				================================================== */

				.goTop {

					padding: 55px 0 65px;


					img {

						width: 45px;

						height: auto;

					}


					.tit {

						padding-top: 12px;

						font-size: 22px;

						line-height: 1.3;

					}

				}

			}

		}

	}

}


/* ============================================================
   Very small mobile
============================================================ */

@media screen and (max-width: 375px) {

	.main_box {


		.block_1 {

			.block_1_main {

				padding-left: 12px;

				padding-right: 12px;


				.product_el {

					padding-left: 15px;

					padding-right: 15px;


					.tit {

						font-size: 19px;

					}


					.txt_box {

						.txt_el {

							font-size: 13px;

						}

					}


					.btn {

						.van-button__text {

							font-size: 14px;

						}

					}

				}

			}

		}


		.block_2 {

			.block_2_main {

				padding-left: 12px;

				padding-right: 12px;


				.msg_box {

					.title {

						font-size: 22px;

					}


					.msg_main,

					.msg_main2 {

						padding-left: 15px;

						padding-right: 15px;

					}


					.msg_main2 {

						.msg_el2 {

							.msg_el2_tit {

								font-size: 18px;

							}

						}

					}

				}

			}

		}

	}

}

</style>


<style scoped>

@font-face {
	font-family: 'Impact';
	src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
	font-family: 'Inter';
	src: url('../../assets/fonts/Inter.ttf');
}
.font1{
	font-family: 'Inter';
	font-weight: bold;
}
.font2{
	font-family: 'Impact';
}
/* ============================================================
   原有列表样式
============================================================ */

>>> .main_box ol,
>>> .main_box ul {

	list-style: initial !important;

	margin: revert !important;

	padding: revert !important;

}


>>> .main_box .block_1_box p {

	margin: 0;

}


/* ============================================================
   Mobile Element UI / Vant
============================================================ */

@media screen and (max-width: 768px) {


	/* 防止 Element UI 产生横向溢出 */

	>>> .main_box .el-table {

		max-width: 100%;

	}


	/* Vant Image */

	>>> .main_box .van-image {

		max-width: 100%;

	}


	/* Popup */

	>>> .van-popup {

		max-width: calc(100vw - 30px);

		box-sizing: border-box;

	}


	/* Popup close */

	>>> .van-popup__close-icon {

		top: 15px;

		right: 15px;

	}

}

</style>